// extracted by mini-css-extract-plugin
export default {"root":"HotKeyTip__root--2E2Zf","root_win":"HotKeyTip__root_win--220Y_","plus":"HotKeyTip__plus--xHX5J","glyph":"HotKeyTip__glyph--mByfB"};